module.exports = __webpack_public_path__ + "img/back_neck_depth.5b321cc3.png";